import { Link } from "react-router-dom";

interface Props {
  children: React.ReactNode;
  href?: string;
  onClick?: () => void;
  size?: "sm" | "md" | "lg";
  type?: "button" | "submit" | "reset";
}

export default function GhostButton({
  children,
  href,
  onClick,
  size = "md",
  type,
}: Props) {
  const padding = size === "sm" ? "10px 24px" : size === "lg" ? "20px 48px" : "14px 36px";
  const fontSize = size === "sm" ? 11 : size === "lg" ? 14 : 13;
  const style = {
    display: "inline-block",
    background: "transparent",
    color: "#F8F4EC",
    fontFamily: "'Bebas Neue', sans-serif",
    fontSize,
    letterSpacing: "0.2em",
    padding,
    borderRadius: 3,
    border: "1px solid #D4A843",
    cursor: "pointer",
    transition: "all 0.2s ease",
    textTransform: "uppercase" as const,
  };

  const hover = (e: React.MouseEvent<HTMLElement>, enter: boolean) => {
    e.currentTarget.style.background = enter ? "#D4A843" : "transparent";
    e.currentTarget.style.color = enter ? "#050505" : "#F8F4EC";
  };

  if (href) {
    return (
      <Link to={href} style={style} onMouseEnter={(e) => hover(e, true)} onMouseLeave={(e) => hover(e, false)}>
        {children}
      </Link>
    );
  }

  return (
    <button type={type} style={style} onClick={onClick} onMouseEnter={(e) => hover(e, true)} onMouseLeave={(e) => hover(e, false)}>
      {children}
    </button>
  );
}
